module.exports = __webpack_public_path__ + "static/media/ру.62cfd883.mp3";